import { Outlet, useLocation } from "react-router-dom";
import { PageEnum, TABLEPAI, LIFT_TABLE_HEADER } from "@/enums/pageEnum";
import { useTranslation } from "react-i18next";
import { BasicTable, HView } from "@/components";
import { LiftColumns, LiftTcPfxBlkNumber } from "@/utils/commonConfig";

export default function Lift() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  if (pathname !== PageEnum.LIFT) return <Outlet />;

  return (
    <div className="p-4">
      <BasicTable
        tableColsRender={[
          ...LiftColumns(true),
          {
            title: t("action"),
            dataIndex: "action",
            renderText: (_: string, record: { id: string }) => (
              <HView
                name={t("view")}
                path={`${PageEnum.LIFT}/detail/${record?.id}`}
                state={record}
              />
            ),
          },
        ]}
        tableName="lift"
        filterTableFields={[
          { ...LiftTcPfxBlkNumber(t) },
          { field: "lmdClientId", label: t("lMDID"), component: "text" },
          { field: "postalCode", label: t("postalCode"), component: "text" },
        ]}
        editTableHeaderUrl={LIFT_TABLE_HEADER}
        isShowCheckbox={false}
        headerTitle={() => t("liftList")}
        requestUrl={TABLEPAI.LIFT_PAGE}
      />
    </div>
  );
}
